import * as React from 'react';
import { Debounce } from 'react-throttle';
import './ManagePowerUsers.scss';
import Button from 'src/components/common/Button';
import Input from 'src/components/common/Input';
import Loader from 'src/components/common/Loader';
import SpecialAlert from 'src/pages/ForgotPasswordView/components/Alert';
import Alert from 'src/components/common/Alert';
import Select from 'src/components/common/Select2';
import Modal from 'src/components/common/Modal';
import handlerService from 'src/services/handlers/handlersService';
import HandlerModel from 'src/model/handler.model';

import PowerUserModel from 'src/model/powerUser.model';
import { ISelectOption } from 'src/components/common/Select2/components/SelectOption/SelectOption';

interface IManagePowerUsersProps {
  isPending: boolean;
  hasError: boolean;
  errorMessage: string;
  onClearAlert(): void;
  powerUsers: PowerUserModel[];
  hasSucceed: boolean;
  searchPowerUsers(searchText: string): void;
  addPowerUser(
    email: string,
    fullName: string,
    handlerId: number,
    mobileNumber: string,
    password: string,
    username: string
  ): void;
  deleteUser(id: number): void;
}

interface IManagePowerUsersState {
  searchText: string;
  userName: string;
  fullName: string;
  email: string;
  mobileNumber: string;
  password: string;
  handler: { name: string; value: number };
  handlers: ISelectOption[];
  createUser: boolean;
  showModal: boolean;
  userModal: { name: string; id: number };
}

class ManagePowerUsers extends React.Component<
  IManagePowerUsersProps,
  IManagePowerUsersState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      searchText: '',
      userName: '',
      fullName: '',
      email: '',
      mobileNumber: '',
      password: '',
      handler: { name: 'None', value: null },
      handlers: [{ name: 'None', value: null }],
      createUser: false,
      showModal: false,
      userModal: { name: '', id: 0 }
    };
  }

  public componentDidMount() {
    this.props.searchPowerUsers('');
  }

  private onSearchTextChange = (searchText: string) => {
    this.setState({ searchText });
  };

  private onUserNameChange = (text: string) => {
    this.setState({ userName: text });
  };

  private onFullNameChange = (text: string) => {
    this.setState({ fullName: text });
  };

  private onEmailChange = (text: string) => {
    this.setState({ email: text });
  };

  private onMobileNumberChange = (text: string) => {
    this.setState({ mobileNumber: text });
  };

  private onPasswordChange = (text: string) => {
    this.setState({ password: text });
  };

  private onHandlerChange = (handler: { name: string; value: number }) => {
    this.setState({ handler });
  };

  private onCreateUserChange = () => {
    this.setState(
      prevState => ({
        createUser: !prevState.createUser
      }),
      () => {
        this.clearUserData();
        this.props.onClearAlert();
      }
    );
  };

  private clearUserData = () => {
    this.setState({
      userName: '',
      fullName: '',
      email: '',
      mobileNumber: '',
      password: '',
      handler: { name: 'None', value: null }
    });
  };

  private onCreateUser = () => {
    this.props.addPowerUser(
      this.state.email,
      this.state.fullName,
      Number(this.state.handler.value),
      this.state.mobileNumber,
      this.state.password,
      this.state.userName
    );
  };

  private onClicSearchText = () => {
    this.props.searchPowerUsers(this.state.searchText);
  };

  private getHandlers(): void {
    const handlers: ISelectOption[] = this.state.handlers;
    handlerService.getHandlers().then((res: HandlerModel[]) => {
      res.forEach(handler =>
        handlers.push({ name: handler.name, value: handler.id })
      );
      this.setState({ handlers });
    });
  }

  private handleShowHideModal = (user: string = '', id: number = 0) => {
    this.setState(prevState => ({
      showModal: !prevState.showModal,
      userModal: { name: user, id }
    }));
  };

  public componentWillMount() {
    this.getHandlers();
  }

  private renderModal = () => {
    return (
      <Modal handleCloseModal={this.handleShowHideModal}>
        <div className="rp-manage-power-users--modal">
          <span
            className="rpds-close"
            onClick={e => this.handleShowHideModal('', 0)}
          />
          <div className="rp-manage-power-users--modal-text">{`Are you sure you want to remove "${this.state.userModal.name}"?`}</div>
          <div className="rp-manage-power-users--modal-buttons">
            <button
              className="secondary-button"
              onClick={e => this.handleShowHideModal('', 0)}
            >
              Cancel
            </button>
            <button
              className="primary-button"
              onClick={e => {
                this.props.deleteUser(this.state.userModal.id);
                this.handleShowHideModal('', 0);
              }}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>
    );
  };

  private renderUserTable = () => {
    return (
      <React.Fragment>
        {this.props.hasSucceed && (
          <Alert
            styleClass={'rp-power-user-alert'}
            type={'success'}
            icon={'rpds-check-circle'}
            handleCloseAlert={this.props.onClearAlert}
            message={'Power user deleted successfully.'}
          />
        )}
        {this.state.showModal && this.renderModal()}
        <div className="rp-manage-power-users--header">
          <h1>Manage Power Users</h1>
          <div className="rp-manage-power-users--search">
            <Debounce time="500" handler="onChange">
              <input
                onChange={e => this.onSearchTextChange(e.target.value)}
                placeholder="Search by name, handler or email"
                onKeyPress={(e: any) => {
                  if (e.key === 'Enter') {
                    this.onClicSearchText();
                  }
                }}
              />
            </Debounce>
            <Button
              label="Search"
              textTransform="uppercase"
              buttonClass="primary-button"
              action={this.onClicSearchText}
            />
          </div>
          <Button
            label="Add new power user"
            textTransform="uppercase"
            buttonClass="primary-button rp-manage-power-users--create-user"
            action={this.onCreateUserChange}
          />
        </div>
        <div className="rp-manage-power-users--table container-fluid">
          <div className="row table-header">
            <div className="col-md-2">Handler</div>
            <div className="col-md-2">user name</div>
            <div className="col-md-3">full name</div>
            <div className="col-md-5">Email address</div>
          </div>
          {this.props.isPending ? <Loader /> : null}
          {this.props.powerUsers.length > 0 &&
            this.props.powerUsers.map(user => (
              <div key={user.id} className="row table-row">
                <div className="col-md-2">{user.handler}</div>
                <div className="col-md-2">{user.username}</div>
                <div className="col-md-3">{user.fullName}</div>
                <div className="col-md-4 table-row--email">{user.email}</div>
                <div
                  className="col-md-1 table-row--delete"
                  onClick={e =>
                    this.handleShowHideModal(user.username, user.id)
                  }
                >
                  Remove
                </div>
              </div>
            ))}
        </div>
      </React.Fragment>
    );
  };

  private renderCreateUser = () => {
    return (
      <React.Fragment>
        {this.props.hasSucceed && (
          <Alert
            styleClass={'rp-power-user-alert'}
            type={'success'}
            icon={'rpds-check-circle'}
            handleCloseAlert={this.props.onClearAlert}
            message={'Power user created successfully.'}
          />
        )}
        <div className="rp-manage-power-users--create">
          <span
            onClick={this.onCreateUserChange}
            className="rpds-close rp-manage-power-users--close-icon"
          />
          <div className="rp-manage-power-users--create-area">
            <h1 className="rp-manage-power-users--create-title">
              Create a new power user
            </h1>
            <Select
              options={this.state.handlers}
              selected={this.state.handler}
              label={'Handler'}
              onSelect={this.onHandlerChange}
            />
            <Input
              label="User Name"
              value={this.state.userName}
              onChange={this.onUserNameChange}
              required={true}
            />
            <Input
              label="Full Name"
              value={this.state.fullName}
              onChange={this.onFullNameChange}
              required={true}
            />
            <Input
              label="Email Address"
              value={this.state.email}
              onChange={this.onEmailChange}
              required={true}
            />
            <Input
              label="Mobile Number"
              value={this.state.mobileNumber}
              onChange={this.onMobileNumberChange}
            />
            <Input
              label="Assign Password"
              value={this.state.password}
              type="password"
              required={true}
              onChange={this.onPasswordChange}
            />
            <Button
              label="Create power user"
              textTransform="uppercase"
              buttonClass="primary-button"
              action={this.onCreateUser}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  public render() {
    return (
      <div className="rp-manage-power-users">
        {this.props.hasError && (
          <SpecialAlert
            type="error"
            icon="rpds-error"
            onClose={this.props.onClearAlert}
            className={'rpds-alert-power-users'}
          >
            {this.props.errorMessage.split('-').map(msg => (
              <p className="rpds-alert-power-user-msg">{msg}</p>
            ))}
          </SpecialAlert>
        )}
        <div className="rp-manage-power-users--content">
          {this.state.createUser
            ? this.renderCreateUser()
            : this.renderUserTable()}
        </div>
      </div>
    );
  }
}

export default ManagePowerUsers;
